/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PutPrescriptionJAHISDataPathsRequestBodyTypename = "PutPrescriptionJAHISDataPathsRequestBody" as const;

/**
 *
 * @export
 * @interface PutPrescriptionJAHISDataPathsRequestBody
 */
export interface PutPrescriptionJAHISDataPathsRequestBody {
  /**
   *
   * @type {string}
   * @memberof PutPrescriptionJAHISDataPathsRequestBody
   */
  jahisData: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PutPrescriptionJAHISDataPathsRequestBody
   */
  readonly __typename?: string;
}

export function PutPrescriptionJAHISDataPathsRequestBodyFromJSON(json: any): PutPrescriptionJAHISDataPathsRequestBody {
  return PutPrescriptionJAHISDataPathsRequestBodyFromJSONTyped(json, false);
}

export function PutPrescriptionJAHISDataPathsRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PutPrescriptionJAHISDataPathsRequestBody {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PutPrescriptionJAHISDataPathsRequestBodyTypename,

    jahisData: json["jahis_data"],
  };
}

export function PutPrescriptionJAHISDataPathsRequestBodyToJSON(
  object?: PutPrescriptionJAHISDataPathsRequestBody | null
): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    jahis_data: value.jahisData,
  };
}
